<template>
    <div class="container">
        <div class="screen">
            <div class="screen__content">
                <h1 class="screen__content__header">change password</h1>
                <!-- <div class="screen__content__header">change password</div> -->
                <div style="display: flex; justify-content: center; align-items: center; margin-top: 5vh;">
                    <el-form :model="ruleForm" ref="ruleForm" status-icon :rules="rules" label-width="100px"
                        class="demo-ruleForm">
                        <el-form-item label="company">
                            <span>{{ this.company }}</span>
                        </el-form-item>
                        <el-form-item label="username" prop="name">
                            <el-input :disabled="true" v-model="ruleForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="original password" prop="orPasswordpass">
                            <el-input type="password" v-model="ruleForm.orPasswordpass" placeholder="Please enter your old password"
                                autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="password" prop="pass">
                            <el-input type="password" v-model="ruleForm.pass" placeholder="Please enter your new password"
                                autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="confirm password" prop="checkPass">
                            <el-input type="password" v-model="ruleForm.checkPass" placeholder="Please enter your new password again"
                                autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item
                            style="width: 100%; display: flex;justify-content: center; align-items: center; margin-top: 3vh;"
                            class="btn-box">
                            <el-button class="btn-grad" @click="submitForm('ruleForm')">submit</el-button>
                            <el-button class="btn-grad1" @click="resetForm('ruleForm')">reset</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="screen__background">
                <span class="screen__background__shape screen__background__shape4"></span>
                <span class="screen__background__shape screen__background__shape3"></span>
                <span class="screen__background__shape screen__background__shape2"></span>
                <span class="screen__background__shape screen__background__shape1"></span>
            </div>
        </div>
    </div>
</template>

<script>
import App from '../../App'
import req from '../../utils/index'
import url1 from '../../config/url1'
import { onDeactivated } from 'vue';
export default {
    data() {
        var checkName = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('用户名不能为空'));
            }
            else {
                callback();
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            }
            else {
                if (this.ruleForm.checkPass == '') {
                    this.$refs.ruleForm.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass1 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            }
            else {
                if (this.ruleForm.orPasswordpass == '') {
                    this.$refs.ruleForm.validateField('orPasswordpass');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            }
            else if (value !== this.ruleForm.pass) {
                callback(new Error('两次输入密码不一致!'));
            }
            else {
                callback();
            }
        };
        return {
            company: '',
            ruleForm: {
                name: '',
                orPasswordpass: '',
                pass: '',
                checkPass: '',
            },
            rules: {
                pass: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                checkPass: [
                    { validator: validatePass2, trigger: 'blur' }
                ],
                name: [
                    { validator: checkName, trigger: 'blur' }
                ],
                orPasswordpass: [
                    { validator: validatePass1, trigger: 'blur' }
                ]
            }
        };
    },
    created() {
        this.getName();
    },
    methods: {
        // 重新登录
        login() {
            localStorage.clear();
            this.$router.push('/login');
        },
        // 获取用户名
        getName() {
            const value = localStorage.getItem('name');
            const value1 = localStorage.getItem('company');
            this.ruleForm.name = value;
            this.company = value1;
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.changePassword();
                }
                else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        changePassword() {
            let URL = `${url1.changePwd}?name=${this.ruleForm.name}&oldPwd=${this.ruleForm.orPasswordpass}&newPwd=${this.ruleForm.checkPass}`;
            req.post(URL).then(res => {
                if (res.data.code === 200) {
                    this.$message({
                        type: 'success',
                        message: '修改密码成功！请重新登录',
                    });
                    localStorage.removeItem('token');
                    localStorage.clear();
                    //跳转到首页
                    this.$router.push("/login");
                }
                else {
                    alert(res.data.message);
                    localStorage.removeItem('token');
                    localStorage.clear();
                    // this.$router.push("/login");
                }
            });
        },
    },
    components: {
        App, onDeactivated
    }
}
</script>

<style lang="less" scoped>
@import url('https://fonts.googleapis.com/css?family=Raleway:400,700');
@import url('https://at.alicdn.com/t/c/font_4739361_b34n54eu8ti.css');
@import url('https://at.alicdn.com/t/c/font_4739361_u75iyv5pqn8.css');

* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: Raleway, sans-serif;
}

body {
    background: linear-gradient(90deg, #C7C5F4, #776BCC) !important;
}

.container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background: linear-gradient(90deg, #C7C5F4, #776BCC) !important;
}

.screen {
    background: linear-gradient(90deg, #5D54A4, #7C78B8);
    position: relative;
    height: 600px;
    width: 500px;
    box-shadow: 0px 0px 24px #5C5696;
}

.screen__content {
    z-index: 1;
    position: relative;
    height: 100%;
}

.screen__background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    -webkit-clip-path: inset(0 0 0 0);
    clip-path: inset(0 0 0 0);
}

.screen__background__shape {
    transform: rotate(45deg);
    position: absolute;
}

.screen__background__shape1 {
    height: 520px;
    width: 520px;
    background: #FFF;
    top: -50px;
    right: 120px;
    border-radius: 0 72px 0 0;
}

.screen__background__shape2 {
    height: 220px;
    width: 220px;
    background: #6C63AC;
    top: -172px;
    right: 0;
    border-radius: 32px;
}

.screen__background__shape3 {
    height: 540px;
    width: 190px;
    background: linear-gradient(270deg, #5D54A4, #6A679E);
    top: -24px;
    right: 0;
    border-radius: 32px;
}

.screen__background__shape4 {
    height: 400px;
    width: 200px;
    background: #7E7BB9;
    top: 420px;
    right: 50px;
    border-radius: 60px;
}

.login {
    width: 350px;
    padding: 30px;
    padding-top: 156px;
}

.login__field {
    padding: 20px 0px;
    position: relative;
}

.login__icon {
    position: absolute;
    top: 30px;
    color: #7875B5;
}

.login__input {
    border: none;
    border-bottom: 2px solid #D1D1D4;
    background: none;
    padding: 10px;
    padding-left: 24px;
    font-weight: 700;
    width: 100%;
    transition: .2s;
}

.login__input:active,
.login__input:focus,
.login__input:hover {
    outline: none;
    border-bottom-color: #6A679E;
}

.login__submit {
    background: #fff;
    font-size: 20px;
    margin-top: 30px;
    padding: 16px 20px;
    border-radius: 26px;
    border: 1px solid #D4D3E8;
    text-transform: uppercase;
    font-weight: 700;
    display: flex;
    align-items: center;
    width: 100%;
    color: #4C489D;
    box-shadow: 0px 2px 2px #5C5696;
    cursor: pointer;
    transition: .2s;
}

.login__submit:active,
.login__submit:focus,
.login__submit:hover {
    border-color: #6A679E;
    outline: none;
}

.button__icon {
    font-size: 24px;
    margin-left: auto;
    color: #7875B5;
}

.social-login {
    position: absolute;
    height: 140px;
    width: 160px;
    text-align: center;
    bottom: 0px;
    right: 2.5vw;
    color: #ffffff;
}

.social-icons {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 10vw;
    // width: 100%;
}

.social-login__icon {
    padding: 25px 10px;
    color: #fff;
    text-decoration: none;
    text-shadow: 0px 0px 8px #7875B5;
}

.screen__content__header {
    text-align: center;
    margin-top: 8%;
    font-weight: 1000;
    line-height: 70px;
    font-size: calc(55vw * 100 / 1920);
    color: transparent;
    background-image: linear-gradient(to right, #c58bf1 0%, #4d77cc 51%, #6e15a1 100%);
    // background-color : ;
    text-shadow: -2px -2px rgba(255, 255, 255, 0.5), 3px 3px rgba(0, 0, 0, 0.5);
    // text-shadow : rgba(255,255,255,0.5) 0 5px 6px, rgba(255,255,255,0.2) 1px 3px 3px;
    -webkit-background-clip: text;




}

::v-deep .screen__content__header::before {
    content: attr(text);
    position: absolute;
    z-index: -1;
    text-shadow: -1px -1px #fff, 5px 4px #333;
}

.form-wrapper {
    margin-top: 5%;
    margin-left: 10%;
}

.el-form-item {
    margin-bottom: 0.2vh;
}

.el-input {
    display: block;
    width: 95%;
    margin-left: 2vw;
    // margin-bottom: 50px;
    border: 0;

    & /deep/ .el-input__inner {
        border: none;
        background-color: rgba(1, 15, 41, 0);
    }

    border-bottom: 1px solid rgb(128, 125, 125);
    box-sizing: border-box;
    font-size: calc(18vw * 100 / 1920);
    outline: none;
}

& /deep/ .el-form-item__label {
    font-size: calc(16vw * 100 / 1920);
    font-weight: bold;
    white-space:nowrap;
    // width: 30vw;
    // margin-right:0.3vw;
    // color: black;
}

.btn-grad {
    background-image: linear-gradient(to right, #B993D6 0%, #8CA6DB 51%, #B993D6 100%)
}

.btn-grad {
    font-size: calc(25vw * 100 / 1920);
    font-weight: 700;
    margin: 10px;
    padding: 15px 45px;
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    box-shadow: 0 0 15px #eee;
    border-radius: 10px;
    // display: block;
}

.btn-grad:hover {
    background-position: right center;
    /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
}

.btn-grad1 {
    background-image: linear-gradient(to right, #9D50BB 0%, #6E48AA 51%, #9D50BB 100%)
}

.btn-grad1 {
    font-size: calc(25vw * 100 / 1920);
    font-weight: 700;
    margin: 10px;
    padding: 15px 45px;
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    color: white;
    box-shadow: 0 0 20px #eee;
    border-radius: 10px;
}

.btn-grad1:hover {
    background-position: right center;
    /* change the direction of the change here */
    color: #fff;
    text-decoration: none;
}

::v-deep .btn-box .el-form-item__content {
    margin-left: 0 !important;
}
</style>